import React from 'react';

const ProcessSection = ({ title, subtitle, steps = [] }) => {
    return (
        <div className="mxd-section padding-pre-grid my-4 my-md-5 py-3 py-md-4">
            <div className="mxd-container grid-container">
                <div className="mxd-block">
                    <div className="mxd-section-title">
                        <div className="container-fluid p-0">
                            <div className="row g-0">
                                <div className="col-12 col-xl-6 mxd-grid-item no-margin">
                                    <div className="mxd-section-title__hrtitle">
                                        <h2 className="reveal-type">{title}</h2>
                                    </div>
                                </div>
                                <div className="col-12 col-xl-6 mxd-grid-item no-margin">
                                    <div className="mxd-section-title__hrdescr">
                                        <p className="anim-uni-in-up">{subtitle}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mxd-approach-list">
                        {steps.map((step, index) => (
                            <div key={index} className="mxd-approach-list__item">
                                <div className="mxd-approach-list__border anim-uni-in-up"></div>
                                <div className="mxd-approach-list__inner">
                                    <div className="container-fluid px-0">
                                        <div className="row gx-0 align-items-center">
                                            <div className="col-12 col-xl-4 mxd-grid-item no-margin">
                                                <div className="mxd-approach-list__title anim-uni-in-up">
                                                    <h6>{step.title}</h6>
                                                </div>
                                            </div>
                                            <div className="col-12 col-xl-8 mxd-grid-item no-margin">
                                                <div className="mxd-approach-list__descr anim-uni-in-up">
                                                    <p>{step.desc}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="mxd-approach-list__border anim-uni-in-up"></div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProcessSection;
